// // import React, { useEffect, useRef, useState } from "react";
// // import { GoogleMap, LoadScript, Data } from "@react-google-maps/api";
// // import Sidebar from "./MapSidebar";
// // // import '../../assets/css/map.css';

// // const mapContainerStyle = {
// //   height: "97vh",
// //   flexGrow: "1",
// // };

// // const center = {
// //   lat: 28.603752,
// //   lng: 77.230188,
// // };

// // const medicalUnitsApi = "https://procam.pythonanywhere.com/api/gps_unit/medicalunits";
// // const ambulancesApi = "https://procam.pythonanywhere.com/api/gps_unit/ambulances";
// // const ambulancePhotosApi = "https://procam.pythonanywhere.com/api/gps_unit_photo/";

// // const AmbulanceMap = () => {
// //   const [map, setMap] = useState(null);
// //   const medicalMarkersRef = useRef([]); // Ref for medical markers (static)
// //   const ambulanceMarkersRef = useRef([]); // Ref for ambulance markers (dynamic)
// //   const [geoJsonData, setGeoJsonData] = useState(null);

// //   useEffect(() => {
// //     // Fetch the GeoJSON file
// //     // alert('fetching route');
// //     fetch("/route.json")
// //       .then((response) => response.json())
// //       .then((data) => setGeoJsonData(data))
// //       .catch((error) => console.error("Error loading GeoJSON file:", error));
// //   }, []);

// //   useEffect(() => {
// //     if (map) {
// //       // Fetch medical markers once
// //       fetchMedicalMarkersFromApi();

// //       // Fetch and update ambulance markers every 5 seconds
// //       fetchAmbulanceMarkersFromApi();
// //       const interval = setInterval(fetchAmbulanceMarkersFromApi, 5000);

// //       return () => clearInterval(interval); // Clear interval on unmount
// //     }
// //   }, [map]);

// //   const fetchMedicalMarkersFromApi = async () => {
// //     try {
// //       const response = await fetch(medicalUnitsApi);
// //       const data = await response.json();

// //       // Create and add medical markers
// //       const medicalMarkers = data.map((item) => {
// //         const marker = new window.google.maps.Marker({
// //           position: { lat: item.latitude, lng: item.longitude },
// //           map, // Add to the map
// //           title: item.name,
// //           icon: {
// //             url: "icons/medical-center.svg",
// //             labelOrigin: new window.google.maps.Point(30, 40),
// //           },
// //           label: {
// //             text: item.name, // Marker label
// //             color: "white",
// //             fontWeight: "bold",
// //             fontSize: "15px",
// //           },
// //         });

// //         // Add info window to each marker
// //         const infoWindow = new window.google.maps.InfoWindow({
// //           content: `
// //             <div>
// //               <h4>${item.name}</h4>
// //               <p>Unit Type: ${item.unit_type}</p>
// //               <p>Latitude: ${item.latitude}</p>
// //               <p>Longitude: ${item.longitude}</p>
// //             </div>
// //           `,
// //         });

// //         marker.addListener("click", () => {
// //           infoWindow.open(map, marker);
// //         });

// //         return marker;
// //       });

// //       // Store medical markers
// //       medicalMarkersRef.current = medicalMarkers;
// //     } catch (error) {
// //       console.error("Error fetching medical markers:", error);
// //     }
// //   };

// //   const fetchAmbulanceMarkersFromApi = async () => {
// //     try {
// //       const responseAmbulance = await fetch(ambulancesApi);
// //       const ambulanceData = await responseAmbulance.json();

// //       // Update ambulance markers
// //       ambulanceData.forEach((item) => {
// //         const existingMarker = ambulanceMarkersRef.current.find(
// //           (marker) => marker.id === item.id
// //         );

// //         if (existingMarker) {
// //           console.log('Update existing marker');
// //           // Update existing marker
// //           existingMarker.setPosition({ lat: item.latitude, lng: item.longitude });
// //           existingMarker.setIcon({
// //             url:
// //               item.unit_type.trim() === "LEAD CAR"
// //                 ? "icons/lead-car-icon.png"
// //                 : item.unit_type.trim() === "TAIL CAR"
// //                   ? "icons/tail-car-icon.png"
// //                   : "icons/ambulance-location-icon.svg",
// //             labelOrigin: new window.google.maps.Point(30, 10),
// //           });

// //           existingMarker.setLabel({
// //             text: item.name,
// //             color:
// //               item.unit_type.trim() === "LEAD CAR" || item.unit_type.trim() === "TAIL CAR"
// //                 ? "white"
// //                 : "red",
// //             fontWeight: "bold",
// //             fontSize: "15px",
// //           });
// //         } else {
// //           // Create a new marker if it doesn't exist
// //           const newMarker = new window.google.maps.Marker({
// //             position: { lat: item.latitude, lng: item.longitude },
// //             map,
// //             title: item.name,
// //             icon: {
// //               url:
// //                 item.unit_type.trim() === "LEAD CAR"
// //                   ? "icons/lead-car-icon.png"
// //                   : item.unit_type.trim() === "TAIL CAR"
// //                     ? "icons/tail-car-icon.png"
// //                     : "icons/ambulance-location-icon.svg",
// //               labelOrigin: new window.google.maps.Point(30, 10),
// //             },
// //             label: {
// //               text: item.name,
// //               color: "red",
// //               fontWeight: "bold",
// //               fontSize: "15px",
// //             },
// //             id: item.id, // Add a unique identifier for the marker
// //           });

// //           const infoWindow = new window.google.maps.InfoWindow({
// //             content: `
// //               <div>
// //                 <h4>${item.name}</h4>
// //                 <p>Latitude: ${item.latitude}</p>
// //                 <p>Longitude: ${item.longitude}</p>
// //               </div>
// //             `,
// //           });

// //           newMarker.addListener("click", () => {
// //             infoWindow.open(map, newMarker);
// //           });

// //           ambulanceMarkersRef.current.push(newMarker);
// //         }
// //       });

// //       // Remove markers that are no longer valid
// //       ambulanceMarkersRef.current = ambulanceMarkersRef.current.filter((marker) => {
// //         const isStillValid = ambulanceData.some((item) => item.id === marker.id);
// //         if (!isStillValid) {
// //           marker.setMap(null); // Remove marker from map
// //         }
// //         return isStillValid;
// //       });
// //     } catch (error) {
// //       console.error("Error fetching ambulance markers:", error);
// //     }
// //   };

// //   return (
// //     <div>
// //       {/* <div id="sidebar">
// //         <Sidebar ambulancePhotosApi={ambulancePhotosApi} />
// //       </div> */}
// //       <div>
// //         <div id="map">
// //           <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
// //             <GoogleMap
// //               mapContainerStyle={mapContainerStyle}
// //               center={center}
// //               zoom={14}
// //               options={{
// //                 mapTypeControl: false,
// //                 streetViewControl: false,
// //                 fullscreenControl: false,
// //                 scaleControl: false,
// //                 rotateControl: false,
// //                 zoomControl: true,
// //               }}
// //               onLoad={(mapInstance) => setMap(mapInstance)}
// //             >
// //               {geoJsonData && (
// //                 <Data
// //                   onLoad={(data) => {
// //                     data.addGeoJson(geoJsonData);
// //                     data.setStyle((feature) => ({
// //                       visible: feature.getGeometry().getType() !== "Point",
// //                       fillColor: "#FF0000",
// //                       strokeColor: "#FF0000",
// //                       strokeWeight: 2,
// //                     }));
// //                   }}
// //                 />
// //               )}
// //             </GoogleMap>
// //           </LoadScript>
// //         </div>
// //       </div>
// //     </div>
// //   );
// // };

// // export default AmbulanceMap;

// import React, { useEffect, useRef, useState } from 'react';
// import { GoogleMap, LoadScript, Data } from '@react-google-maps/api';
// import Sidebar from './MapSidebar';
// import { TfiMenu } from 'react-icons/tfi';

// const geoJsonData = {
//   type: 'FeatureCollection',
//   features: [
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'LineString',
//         coordinates: [
//           [88.34597930717436, 22.5596589064033, 0],
//           [88.34520527948865, 22.55746855257435, 0],
//           [88.34452133411094, 22.55566083462675, 0],
//           [88.34447033287927, 22.55556941244379, 0],
//           [88.34437029430617, 22.55544936959521, 0],
//           [88.34433135899357, 22.55538521453196, 0],
//           [88.3443064668773, 22.5552974852522, 0],
//           [88.34430063050704, 22.55510470700436, 0],
//           [88.34406357864317, 22.55437367906706, 0],
//           [88.34371579456025, 22.55339933239251, 0],
//           [88.34355463399777, 22.55298597635218, 0],
//           [88.34345895693922, 22.55279837149462, 0],
//           [88.34327364551056, 22.55252478794927, 0],
//           [88.3430201285064, 22.55226800290306, 0],
//           [88.34238826323347, 22.5518405795143, 0],
//           [88.34142184593732, 22.55123192961312, 0],
//           [88.34046332926232, 22.55064924460414, 0],
//           [88.33935719127683, 22.54998174726224, 0],
//           [88.3384100484658, 22.54938986441273, 0],
//           [88.33748005184218, 22.54881270460363, 0],
//           [88.33648304292446, 22.5481815653561, 0],
//           [88.33564544066749, 22.54767460402599, 0],
//           [88.33496199549671, 22.54725735632304, 0],
//           [88.33455040298863, 22.54697089112188, 0],
//           [88.33422806096527, 22.54675980271078, 0],
//           [88.33337270855303, 22.54624478754688, 0],
//           [88.33304803666529, 22.54603158522948, 0],
//           [88.33284150580906, 22.54592798868503, 0],
//           [88.33244338517538, 22.54583366030495, 0],
//           [88.33217636394254, 22.54579995478716, 0],
//           [88.33189159887553, 22.54575694013152, 0],
//           [88.33171510280884, 22.54568803585115, 0],
//           [88.33159685991635, 22.54554482715932, 0],
//           [88.33152125846672, 22.54545278086249, 0],
//           [88.33143527552834, 22.54533626839382, 0],
//           [88.33138800403412, 22.54518983502253, 0],
//           [88.33134097492379, 22.54506242579681, 0],
//           [88.33124641332564, 22.54491170232394, 0],
//           [88.33097993130878, 22.54472089664265, 0],
//           [88.33037004661215, 22.54427609073065, 0],
//           [88.33007776175413, 22.54408205287441, 0],
//           [88.3298764800301, 22.54397136178984, 0],
//           [88.32978501855597, 22.54394228469928, 0],
//           [88.32967416962472, 22.54394628671438, 0],
//           [88.32957664807596, 22.54402897344885, 0],
//           [88.32949914060929, 22.54414291747043, 0],
//           [88.32941831199085, 22.5446684808575, 0],
//           [88.32944480609795, 22.54505366373808, 0],
//           [88.3295215875457, 22.5458174470872, 0],
//           [88.32952920369763, 22.54623188777337, 0],
//           [88.32948944082055, 22.54718775438018, 0],
//           [88.32952161758683, 22.54743246814255, 0],
//           [88.3296201102893, 22.54769915782484, 0],
//           [88.32980266692168, 22.54819603721066, 0],
//           [88.33007678934997, 22.54890095565627, 0],
//           [88.3302832551072, 22.54943932162882, 0],
//           [88.33052618705693, 22.55004812451995, 0],
//           [88.33073356060692, 22.55055953767161, 0],
//           [88.33076115195641, 22.55063529065166, 0],
//           [88.3308129257554, 22.55081677325725, 0],
//           [88.33114552524616, 22.55171720551381, 0],
//           [88.33147528625094, 22.55267154421703, 0],
//           [88.3316368665848, 22.55310408283659, 0],
//           [88.33185027853084, 22.55380027364527, 0],
//           [88.33196719877563, 22.55425379707865, 0],
//           [88.33199071031503, 22.55468383023462, 0],
//           [88.33192812649177, 22.55499470218717, 0],
//           [88.33183377783733, 22.55532187758627, 0],
//           [88.33174009092298, 22.55562719404746, 0],
//           [88.33174831336409, 22.55586499643538, 0],
//           [88.33177744925763, 22.55601207933771, 0],
//           [88.33182127743036, 22.55621883594877, 0],
//           [88.33191478537452, 22.55649061561452, 0],
//           [88.33213378620724, 22.55702811068878, 0],
//           [88.33238049777263, 22.5575994256438, 0],
//           [88.33262246087217, 22.55819159346845, 0],
//           [88.33292514909846, 22.55887934113122, 0],
//           [88.33320408729384, 22.55938418712903, 0],
//           [88.33345019016798, 22.55979680808852, 0],
//           [88.33375132072611, 22.56023689405816, 0],
//           [88.33409401747546, 22.5605999240113, 0],
//           [88.33461284224495, 22.56095922840526, 0],
//           [88.33534553970173, 22.56141587774765, 0],
//           [88.33601726355522, 22.56183750675443, 0],
//           [88.33666670323815, 22.5622494460733, 0],
//           [88.33696032856263, 22.56245506334593, 0],
//           [88.3371971631158, 22.56266993671303, 0],
//           [88.33780455119926, 22.56320306914668, 0],
//           [88.33802284277951, 22.56338518428122, 0],
//           [88.33825386753522, 22.56350464545537, 0],
//           [88.33846107447539, 22.56353048840933, 0],
//           [88.33869515443891, 22.56345069826465, 0],
//           [88.33891770420549, 22.56330402890704, 0],
//           [88.3391332859488, 22.56317563063101, 0],
//           [88.33940649883387, 22.56300832608802, 0],
//           [88.33962052722936, 22.56290427415959, 0],
//           [88.3399944712518, 22.56280040384097, 0],
//           [88.34021347454939, 22.5627584949319, 0],
//           [88.34059166144667, 22.5627064248418, 0],
//           [88.34083097165241, 22.56268702911369, 0],
//           [88.34126890153269, 22.56269401833723, 0],
//           [88.34145496971718, 22.5627034920908, 0],
//           [88.34182762251852, 22.56275080008984, 0],
//           [88.3421287964141, 22.56280605391937, 0],
//           [88.34253606273032, 22.56289748451644, 0],
//           [88.34284184983481, 22.56296238914044, 0],
//           [88.34305867858677, 22.56302724996632, 0],
//           [88.34335599918776, 22.56314273049529, 0],
//           [88.34375777098651, 22.56334891048345, 0],
//           [88.344283490216, 22.56364129507235, 0],
//           [88.34474436565594, 22.56389242209972, 0],
//           [88.34508012096337, 22.564146734762, 0],
//           [88.34539913066948, 22.56433181621513, 0],
//           [88.34567872176771, 22.56437237304114, 0],
//           [88.34602209234127, 22.56433538619536, 0],
//           [88.34657311021232, 22.56412895594373, 0],
//           [88.34673165061336, 22.5639795509419, 0],
//           [88.34684373935214, 22.5638376633184, 0],
//           [88.34696790488326, 22.56366415158676, 0],
//           [88.34710915656059, 22.5634156693019, 0],
//           [88.34724039676196, 22.56316345146605, 0],
//           [88.34743735042716, 22.5631344595344, 0],
//           [88.34756495236749, 22.56252953676531, 0],
//           [88.34765792068336, 22.56225545370132, 0],
//           [88.34781404483111, 22.56181136367946, 0],
//           [88.34834887603164, 22.56068687467956, 0],
//           [88.34846092383363, 22.56044155762093, 0],
//           [88.34852421446173, 22.56022325484318, 0],
//           [88.34860160581101, 22.55995541832245, 0],
//           [88.34905604202639, 22.55863990452845, 0],
//           [88.34924304421367, 22.55813403914094, 0],
//           [88.34969899646974, 22.55699594553423, 0],
//           [88.34995884440671, 22.55635772751469, 0],
//           [88.35009025483821, 22.55598955602007, 0],
//           [88.35015285232498, 22.55555079865913, 0],
//           [88.35019599225987, 22.55530588318731, 0],
//           [88.35027528673697, 22.55521775213427, 0],
//           [88.3506936452536, 22.55483721651103, 0],
//           [88.35174380858732, 22.55376268502003, 0],
//           [88.35281394240413, 22.55270543387929, 0],
//           [88.35372892332336, 22.5516133711107, 0],
//           [88.3545184481511, 22.55061986996907, 0],
//           [88.35497980698675, 22.55010604816467, 0],
//           [88.35533141347135, 22.54993469129264, 0],
//           [88.35610696127782, 22.549612230018, 0],
//           [88.35720330422302, 22.54918549689414, 0],
//           [88.35821244349421, 22.5487770604902, 0],
//           [88.35830540923634, 22.54871734627907, 0],
//           [88.35883713950489, 22.54837629495749, 0],
//           [88.35963176182392, 22.54758340522773, 0],
//           [88.3598953716777, 22.54738491242475, 0],
//           [88.36113722719952, 22.54676600322722, 0],
//           [88.36139005833974, 22.54663630377144, 0],
//           [88.36277411802791, 22.54571613992781, 0],
//           [88.36566413569562, 22.54364196368896, 0],
//           [88.365968289126, 22.54293758569133, 0],
//           [88.36573241758418, 22.54177175018211, 0],
//           [88.36541662624546, 22.54030353305251, 0],
//           [88.36506841298602, 22.53854348829827, 0],
//           [88.36482246916043, 22.53718519649737, 0],
//           [88.36479916665063, 22.53691986839218, 0],
//           [88.3648108071164, 22.53662062503009, 0],
//           [88.36487750609238, 22.53601737738798, 0],
//           [88.36490587721046, 22.53562653304295, 0],
//           [88.36478601836077, 22.53503942335616, 0],
//           [88.36465240445679, 22.53441357351302, 0],
//           [88.36454805439178, 22.53369456318103, 0],
//           [88.36451263391265, 22.53330333220933, 0],
//           [88.36454892517145, 22.53292037495412, 0],
//           [88.36480002144619, 22.53215490623122, 0],
//           [88.36508750223899, 22.53116986865106, 0],
//           [88.36536644316644, 22.53018439921015, 0],
//           [88.36558750216835, 22.52941745667948, 0],
//           [88.36582592632993, 22.52866349505868, 0],
//           [88.365953389196, 22.52779613111406, 0],
//           [88.36596014126188, 22.52766336255885, 0],
//           [88.36601005137508, 22.52679374232118, 0],
//           [88.36600452055691, 22.52612776368941, 0],
//           [88.36577094979, 22.52483776415517, 0],
//           [88.36550631296338, 22.5237477657481, 0],
//           [88.36527743328647, 22.52284907652333, 0],
//           [88.36513705713787, 22.52212751625112, 0],
//           [88.36507958373002, 22.52166993604368, 0],
//           [88.3649928433471, 22.5208280495158, 0],
//           [88.36499192525075, 22.52041979984361, 0],
//           [88.36512772866642, 22.51987228341258, 0],
//           [88.36529813105966, 22.51936925567641, 0],
//           [88.36543827680654, 22.51894934050063, 0],
//           [88.36578061126427, 22.51805707413098, 0],
//           [88.3660507165262, 22.51726592184345, 0],
//           [88.36611740305021, 22.51678541426767, 0],
//           [88.3661029694876, 22.5166040540396, 0],
//           [88.36597906430265, 22.51646627453737, 0],
//           [88.36594111795914, 22.51629690626984, 0],
//           [88.36601565115372, 22.51612902140448, 0],
//           [88.36616360391912, 22.51592367313037, 0],
//           [88.36610757568182, 22.51578012386494, 0],
//           [88.36585013184393, 22.51521512744134, 0],
//           [88.36559238991032, 22.51488640781921, 0],
//           [88.36537586062694, 22.51467684003375, 0],
//           [88.3651315485897, 22.51448443232236, 0],
//           [88.36473311984093, 22.51427053500286, 0],
//           [88.36426304289989, 22.51414946566294, 0],
//           [88.36324892361543, 22.5140134906413, 0],
//           [88.36179149430515, 22.51386833275783, 0],
//           [88.36036656785454, 22.51372036502836, 0],
//           [88.3592183771283, 22.51359116227349, 0],
//           [88.35764947265189, 22.51344318695081, 0],
//           [88.35599216371588, 22.5132576587218, 0],
//           [88.35442033237409, 22.51309938486984, 0],
//           [88.3532191078533, 22.51297800306064, 0],
//           [88.3518216633141, 22.51283457540881, 0],
//           [88.35134029013486, 22.51276385550406, 0],
//           [88.35078868569484, 22.51279605793006, 0],
//           [88.34986521612126, 22.51283071314828, 0],
//           [88.34886602137593, 22.51303860280306, 0],
//           [88.34807002752626, 22.5133301518209, 0],
//           [88.34744386691106, 22.51366952018737, 0],
//           [88.34702946984407, 22.51399005708073, 0],
//           [88.34616684405623, 22.51483799635489, 0],
//           [88.346054498605, 22.5149746377789, 0],
//           [88.34600361988663, 22.51507045661843, 0],
//           [88.345961287007, 22.51517796305919, 0],
//           [88.34592525570125, 22.51538855196116, 0],
//           [88.3458385809002, 22.5158198664536, 0],
//           [88.3457507838127, 22.51627988978683, 0],
//           [88.34572103394007, 22.51669765806068, 0],
//           [88.34570577164467, 22.51690558401557, 0],
//           [88.34571297064268, 22.51700067986615, 0],
//           [88.3457403270156, 22.51724886886415, 0],
//           [88.34582357416579, 22.51772959005314, 0],
//           [88.34594942414121, 22.51825933316142, 0],
//           [88.3460133066938, 22.51851798422092, 0],
//           [88.34614601119681, 22.51908198133438, 0],
//           [88.34625463274544, 22.51957601705764, 0],
//           [88.34638399754031, 22.52011458176412, 0],
//           [88.34649063007001, 22.52049471353887, 0],
//           [88.34653856692665, 22.52073843732277, 0],
//           [88.34658524299, 22.52112790638823, 0],
//           [88.3465921299362, 22.52149661739583, 0],
//           [88.34659076857137, 22.52183649426648, 0],
//           [88.3465759908085, 22.52204491451823, 0],
//           [88.34656563486406, 22.52226783377663, 0],
//           [88.34654999295114, 22.52258878362462, 0],
//           [88.34651330106483, 22.5228878230681, 0],
//           [88.34647327121037, 22.52327139015034, 0],
//           [88.34644735027304, 22.52355411343487, 0],
//           [88.34643758489631, 22.52377234246087, 0],
//           [88.34640022060435, 22.52449604776871, 0],
//           [88.34637021510483, 22.52542314352735, 0],
//           [88.34620327205592, 22.52646985762846, 0],
//           [88.34541283466936, 22.52907621752485, 0],
//           [88.34557999022172, 22.53041056304442, 0],
//           [88.34590718938524, 22.53297285164139, 0],
//           [88.34608083574335, 22.53523889206485, 0],
//           [88.34631442198123, 22.53646064705332, 0],
//           [88.34654135283488, 22.53749371347239, 0],
//           [88.3468782020584, 22.53948717167757, 0],
//           [88.34718910958182, 22.54150197222068, 0],
//           [88.34711853139946, 22.54161026496238, 0],
//           [88.34688022906002, 22.54163455442639, 0],
//           [88.3461738639396, 22.5416700384723, 0],
//           [88.34550947997782, 22.54162689993009, 0],
//           [88.34427647647595, 22.54150459270059, 0],
//           [88.34326887550628, 22.54133800965689, 0],
//           [88.34220095120622, 22.54105912154015, 0],
//           [88.34116459302206, 22.54082957985295, 0],
//           [88.33985180338225, 22.5405834356707, 0],
//           [88.338135870493, 22.54015015463316, 0],
//           [88.33739876877881, 22.53996126737372, 0],
//           [88.33667149505703, 22.53987098997089, 0],
//           [88.33628238163878, 22.53992434954808, 0],
//           [88.33575276191664, 22.54014722021531, 0],
//           [88.33456376496277, 22.54070086593107, 0],
//           [88.33442988256807, 22.54076469106245, 0],
//           [88.33357494510517, 22.54125458628243, 0],
//           [88.33281937525896, 22.54164845893517, 0],
//           [88.33198984517405, 22.54204931598775, 0],
//           [88.33186051987154, 22.54209385156214, 0],
//           [88.33159436444542, 22.5422162434687, 0],
//           [88.33140434080764, 22.54228623939881, 0],
//           [88.3311740276345, 22.54240282740522, 0],
//           [88.33065538332268, 22.54267606977014, 0],
//           [88.33012436432627, 22.54306321819762, 0],
//           [88.32975272867704, 22.54339968641827, 0],
//           [88.32967155489708, 22.54354378573712, 0],
//           [88.3296776144001, 22.54365535529443, 0],
//           [88.32973349157066, 22.54375249706503, 0],
//           [88.32984638394723, 22.54386609361054, 0],
//           [88.33013792330715, 22.54406191666678, 0],
//           [88.33047553746576, 22.54429305118201, 0],
//           [88.33080226771595, 22.5445175442093, 0],
//           [88.33120062829309, 22.54481415341923, 0],
//           [88.33135040643512, 22.54494260099707, 0],
//           [88.33141399693916, 22.54507991253588, 0],
//           [88.33152121031779, 22.54531003287099, 0],
//           [88.3316309810371, 22.54546472779608, 0],
//           [88.33173278046789, 22.5454961905848, 0],
//           [88.3321061518108, 22.54552794798366, 0],
//           [88.33231410770567, 22.54555252292146, 0],
//           [88.33245497828423, 22.54561951766009, 0],
//           [88.33278248071868, 22.54581323674655, 0],
//           [88.33317678099527, 22.54605636305227, 0],
//           [88.3337386635005, 22.54636698861388, 0],
//           [88.33432493552654, 22.54674320734085, 0],
//           [88.3349639118952, 22.54714287617018, 0],
//           [88.33551560486552, 22.54747878960276, 0],
//           [88.33613739855457, 22.54784374023869, 0],
//           [88.3365947410216, 22.54811859633592, 0],
//           [88.33712938290815, 22.54845337147899, 0],
//           [88.33765971148118, 22.54879514445044, 0],
//           [88.33818648162982, 22.54912569038672, 0],
//           [88.33889457645792, 22.54958286872968, 0],
//           [88.33958645110648, 22.55000819762979, 0],
//           [88.34021000146495, 22.55036406338726, 0],
//           [88.34028975279365, 22.55039247428811, 0],
//           [88.3403368548737, 22.55038201029273, 0],
//           [88.34035444083474, 22.55031692150643, 0],
//           [88.3403654610273, 22.55016143238018, 0],
//           [88.34042768609939, 22.54930088922703, 0],
//           [88.34049688586174, 22.54839284019686, 0],
//           [88.34058670078392, 22.5470917098553, 0],
//           [88.34062687586861, 22.5462175225316, 0],
//           [88.34064100210621, 22.54532899857999, 0],
//           [88.34062234991163, 22.54445760694488, 0],
//           [88.34058752942515, 22.54357529025831, 0],
//           [88.34054358965962, 22.54262006824782, 0],
//           [88.34051312748909, 22.54241087482901, 0],
//           [88.34049977817713, 22.54229325772872, 0],
//           [88.34046726377021, 22.54218152953211, 0],
//           [88.34042607945644, 22.54205332536285, 0],
//           [88.34031829624925, 22.54176984337772, 0],
//           [88.3401494654051, 22.54148766355909, 0],
//           [88.34007277201624, 22.54136911632029, 0],
//           [88.33990737926379, 22.54118663816772, 0],
//           [88.33976002661214, 22.54100643835249, 0],
//           [88.33979876369943, 22.54097977383544, 0],
//           [88.33992240690793, 22.54109610769039, 0],
//           [88.34012200050125, 22.54132876639791, 0],
//           [88.34029198092291, 22.54158719304614, 0],
//           [88.34036732081474, 22.541751628121, 0],
//           [88.34046945894306, 22.54203284946186, 0],
//           [88.34057691457707, 22.54240048963064, 0],
//           [88.34064221748197, 22.54328616868093, 0],
//           [88.34072858197642, 22.54483534003561, 0],
//           [88.34075162893367, 22.54607345068687, 0],
//           [88.340759318336, 22.54682920804775, 0],
//           [88.34080979935067, 22.54693114307826, 0],
//           [88.34104563709883, 22.54712955673592, 0],
//           [88.34121203198833, 22.54721081788462, 0],
//           [88.34162226560063, 22.54736173663381, 0],
//           [88.34191818667871, 22.54743630991312, 0],
//           [88.34239148869479, 22.5475116111303, 0],
//           [88.34261568317352, 22.54752582398784, 0],
//           [88.3428312892313, 22.54750524531984, 0],
//           [88.34294446119583, 22.54744857405882, 0],
//           [88.34305583430562, 22.54741503608934, 0],
//           [88.343196123837, 22.54745561005268, 0],
//           [88.3433368092504, 22.54746032565589, 0],
//           [88.34352857923943, 22.54741375206998, 0],
//           [88.34382650916567, 22.54727789720362, 0],
//           [88.34412226080039, 22.54713455104035, 0],
//           [88.34532288699934, 22.54650396310515, 0],
//           [88.34563540647719, 22.54637144859392, 0],
//           [88.34574191064281, 22.54633792123098, 0],
//           [88.34602672655582, 22.54623061699888, 0],
//           [88.34614650326887, 22.54619367759655, 0],
//           [88.3462014659331, 22.5461726113421, 0],
//           [88.34632435711217, 22.54614754304069, 0],
//           [88.3463590356975, 22.546198312982, 0],
//           [88.34574339003962, 22.54637844631172, 0],
//           [88.34535579656807, 22.54653896300116, 0],
//           [88.34405008391374, 22.54722765979761, 0],
//           [88.343708328703, 22.54739621773155, 0],
//           [88.34325437512614, 22.547551495832, 0],
//           [88.34318022834515, 22.54763654366441, 0],
//           [88.34308712544544, 22.54768539683889, 0],
//           [88.34291786603428, 22.54765679137364, 0],
//           [88.34275599290213, 22.54762134722051, 0],
//           [88.3423331683008, 22.54757582580084, 0],
//           [88.3418336231625, 22.5475315037278, 0],
//           [88.3415663521007, 22.54753036064696, 0],
//           [88.34142902800122, 22.54755884482006, 0],
//           [88.3413047500635, 22.54761172614601, 0],
//           [88.34124036044531, 22.5476486596402, 0],
//           [88.3411711412606, 22.54777534871404, 0],
//           [88.34351845044212, 22.55269554724354, 0],
//           [88.34381254781826, 22.55328763315919, 0],
//           [88.3441691755531, 22.55427720200015, 0],
//           [88.34453268783714, 22.55526021981085, 0],
//           [88.34459444367343, 22.55546335751741, 0],
//           [88.34511454196097, 22.55684761981721, 0],
//           [88.34591767958256, 22.55917016856711, 0],
//         ],
//       },
//       properties: { name: 'TSK25k- ops6- 25.122k', tessellate: true },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.32970728131706, 22.54793298448843, 0],
//       },
//       properties: { name: '3k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.33206586760919, 22.55646679451407, 0],
//       },
//       properties: { name: '4k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.33792607926497, 22.5631107180631, 0],
//       },
//       properties: { name: '5k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.33388258493639, 22.5465894730723, 0],
//       },
//       properties: { name: '2k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34599836271015, 22.55965666459369, 0],
//       },
//       properties: { name: 'Start' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.3459327506131, 22.55918523702179, 0],
//       },
//       properties: { name: 'Finish' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.3414156582345, 22.55133829026072, 0],
//       },
//       properties: { name: '1k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34676226084498, 22.56389959353329, 0],
//       },
//       properties: { name: '6k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.35012140236482, 22.5555599716831, 0],
//       },
//       properties: { name: '7k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.35649816505023, 22.54945762078112, 0],
//       },
//       properties: { name: '8k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.36495420432131, 22.54410414508477, 0],
//       },
//       properties: { name: '9k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.36485606765068, 22.53535127018718, 0],
//       },
//       properties: { name: '10k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.36596624143458, 22.52708294648803, 0],
//       },
//       properties: { name: '11k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.36563586348245, 22.51828934721021, 0],
//       },
//       properties: { name: '12k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.36041658131558, 22.51369662805844, 0],
//       },
//       properties: { name: '13k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.35060587198143, 22.51279394413069, 0],
//       },
//       properties: { name: '14k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34607849619073, 22.51899050109114, 0],
//       },
//       properties: { name: '15k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.3454041997698, 22.5289830992155, 0],
//       },
//       properties: { name: '16k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34654394000962, 22.53760590401064, 0],
//       },
//       properties: { name: '17k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34187155558863, 22.54099499676664, 0],
//       },
//       properties: { name: '18k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.33314913453621, 22.54145754496819, 0],
//       },
//       properties: { name: '19k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.3338415928082, 22.54644109010972, 0],
//       },
//       properties: { name: '20k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34054559011568, 22.54807524924961, 0],
//       },
//       properties: { name: '21k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34057373143689, 22.54230483369024, 0],
//       },
//       properties: { name: '22k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.3450678438505, 22.54663789187204, 0],
//       },
//       properties: { name: '23k' },
//     },
//     {
//       type: 'Feature',
//       geometry: {
//         type: 'Point',
//         coordinates: [88.34186280769242, 22.54924872168946, 0],
//       },
//       properties: { name: '24k' },
//     },
//   ],
// };

// const mapContainerStyle = {
//   height: '97vh',
//   flexGrow: '1',
// };

// const center = {
//   lat: 28.603752,
//   lng: 77.230188,
// };

// const medicalUnitsApi =
//   'https://procam.pythonanywhere.com/api/gps_unit/medicalunits';
// const ambulancesApi =
//   'https://procam.pythonanywhere.com/api/gps_unit/ambulances';
// const ambulancePhotosApi =
//   'https://procam.pythonanywhere.com/api/gps_unit_photo/';

// const AmbulanceMap = () => {
//   const [map, setMap] = useState(null);
//   const medicalMarkersRef = useRef([]); // Ref for medical markers (static)
//   const ambulanceMarkersRef = useRef([]); // Ref for ambulance markers (dynamic)
//   // const [geoJsonData, setGeoJsonData] = useState(null);
//   const [showSidebar, setShowSidebar] = useState(true);

//   // useEffect(() => {
//   //   // Fetch the GeoJSON file
//   //   fetch('/route.json')
//   //     .then((response) => response.json())
//   //     .then((data) => setGeoJsonData(data))
//   //     .catch((error) => console.error('Error loading GeoJSON file:', error));
//   // }, []);

//   useEffect(() => {
//     if (map) {
//       // Fetch medical markers once
//       fetchMedicalMarkersFromApi();

//       // Fetch and update ambulance markers every 5 seconds
//       fetchAmbulanceMarkersFromApi();
//       const interval = setInterval(fetchAmbulanceMarkersFromApi, 5000);

//       return () => clearInterval(interval); // Clear interval on unmount
//     }
//   }, [map]);

//   const fetchMedicalMarkersFromApi = async () => {
//     try {
//       const response = await fetch(medicalUnitsApi);
//       const data = await response.json();
//       console.log('Medical Units Data:', data);

//       // Create and add medical markers
//       const medicalMarkers = data.map((item) => {
//         const marker = new window.google.maps.Marker({
//           position: { lat: item.latitude, lng: item.longitude },
//           map, // Add to the map
//           title: item.name,
//           icon: {
//             url: 'icons/medical-center.svg',
//             labelOrigin: new window.google.maps.Point(30, 40),
//           },
//           label: {
//             text: item.name, // Marker label
//             color: 'white',
//             fontWeight: 'bold',
//             fontSize: '15px',
//           },
//         });

//         // Add info window to each marker
//         const infoWindow = new window.google.maps.InfoWindow({
//           content: `
//             <div>
//               <h4>${item.name}</h4>
//               <p>Unit Type: ${item.unit_type}</p>
//               <p>Latitude: ${item.latitude}</p>
//               <p>Longitude: ${item.longitude}</p>
//             </div>
//           `,
//         });

//         marker.addListener('click', () => {
//           infoWindow.open(map, marker);
//         });

//         return marker;
//       });

//       // Store medical markers
//       medicalMarkersRef.current = medicalMarkers;
//     } catch (error) {
//       console.error('Error fetching medical markers:', error);
//     }
//   };

//   const fetchAmbulanceMarkersFromApi = async () => {
//     try {
//       const responseAmbulance = await fetch(ambulancesApi);
//       const ambulanceData = await responseAmbulance.json();
//       console.log('Ambulance Data:', ambulanceData);

//       // Update ambulance markers
//       ambulanceData.forEach((item) => {
//         const existingMarker = ambulanceMarkersRef.current.find(
//           (marker) => marker.id === item.id
//         );

//         if (existingMarker) {
//           // Update existing marker
//           existingMarker.setPosition({
//             lat: item.latitude,
//             lng: item.longitude,
//           });
//           existingMarker.setIcon({
//             url:
//               item.unit_type.trim() === 'LEAD CAR'
//                 ? 'icons/lead-car-icon.png'
//                 : item.unit_type.trim() === 'TAIL CAR'
//                 ? 'icons/tail-car-icon.png'
//                 : 'icons/ambulance-location-icon.svg',
//             labelOrigin: new window.google.maps.Point(30, 10),
//           });

//           existingMarker.setLabel({
//             text: item.name,
//             color:
//               item.unit_type.trim() === 'LEAD CAR' ||
//               item.unit_type.trim() === 'TAIL CAR'
//                 ? 'white'
//                 : 'red',
//             fontWeight: 'bold',
//             fontSize: '15px',
//           });
//         } else {
//           // Create a new marker if it doesn't exist
//           const newMarker = new window.google.maps.Marker({
//             position: { lat: item.latitude, lng: item.longitude },
//             map,
//             title: item.name,
//             icon: {
//               url:
//                 item.unit_type.trim() === 'LEAD CAR'
//                   ? 'icons/lead-car-icon.png'
//                   : item.unit_type.trim() === 'TAIL CAR'
//                   ? 'icons/tail-car-icon.png'
//                   : 'icons/ambulance-location-icon.svg',
//               labelOrigin: new window.google.maps.Point(30, 10),
//             },
//             label: {
//               text: item.name,
//               color: 'red',
//               fontWeight: 'bold',
//               fontSize: '15px',
//             },
//             id: item.id, // Add a unique identifier for the marker
//           });

//           const infoWindow = new window.google.maps.InfoWindow({
//             content: `
//               <div>
//                 <h4>${item.name}</h4>
//                 <p>Latitude: ${item.latitude}</p>
//                 <p>Longitude: ${item.longitude}</p>
//               </div>
//             `,
//           });

//           newMarker.addListener('click', () => {
//             infoWindow.open(map, newMarker);
//           });

//           ambulanceMarkersRef.current.push(newMarker);
//         }
//       });

//       // Remove markers that are no longer valid
//       ambulanceMarkersRef.current = ambulanceMarkersRef.current.filter(
//         (marker) => {
//           const isStillValid = ambulanceData.some(
//             (item) => item.id === marker.id
//           );
//           if (!isStillValid) {
//             marker.setMap(null); // Remove marker from map
//           }
//           return isStillValid;
//         }
//       );
//     } catch (error) {
//       console.error('Error fetching ambulance markers:', error);
//     }
//   };

//   const mapStyle = [
//     { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
//     { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
//     {
//       featureType: 'administrative.locality',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'geometry',
//       stylers: [{ color: '#263c3f' }],
//     },
//     {
//       featureType: 'poi.park',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#6b9a76' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry',
//       stylers: [{ color: '#38414e' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#212a37' }],
//     },
//     {
//       featureType: 'road',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#9ca5b3' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry',
//       stylers: [{ color: '#746855' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'geometry.stroke',
//       stylers: [{ color: '#1f2835' }],
//     },
//     {
//       featureType: 'road.highway',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#f3d19c' }],
//     },
//     {
//       featureType: 'transit',
//       elementType: 'geometry',
//       stylers: [{ color: '#2f3948' }],
//     },
//     {
//       featureType: 'transit.station',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#d59563' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'geometry',
//       stylers: [{ color: '#17263c' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.fill',
//       stylers: [{ color: '#515c6d' }],
//     },
//     {
//       featureType: 'water',
//       elementType: 'labels.text.stroke',
//       stylers: [{ color: '#17263c' }],
//     },
//   ];

//   return (
//     <div style={{ display: 'flex', height: '100vh' }}>
//       {/* Sidebar on the left */}
//       {showSidebar ? (
//         <div style={{ width: '365px', overflow: 'auto' }}>
//           <Sidebar
//             ambulancePhotosApi={ambulancePhotosApi}
//             setShowSidebar={setShowSidebar}
//           />
//         </div>
//       ) : (
//         <div
//           style={{
//             position: 'absolute',
//             top: '1rem',
//             left: '20px',
//             zIndex: 999,
//           }}
//         >
//           <TfiMenu
//             style={{ color: '#007bff', fontSize: '25px', cursor: 'pointer' }}
//             onClick={() => setShowSidebar(true)}
//             cursor='pointer'
//           />
//         </div>
//       )}

//       {/* Map on the right */}
//       <div style={{ flexGrow: 1 }}>
//         <LoadScript googleMapsApiKey= {process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
//           <GoogleMap
//             mapContainerStyle={mapContainerStyle}
//             center={center}
//             zoom={14}
//             options={{
//               styles: mapStyle,
//               mapTypeControl: false,
//               streetViewControl: false,
//               fullscreenControl: false,
//               scaleControl: false,
//               rotateControl: false,
//               zoomControl: true,
//             }}
//             onLoad={(mapInstance) => setMap(mapInstance)}
//           >
//             {geoJsonData && (
//               <Data
//                 onLoad={(data) => {
//                   data.addGeoJson(geoJsonData);
//                   data.setStyle((feature) => ({
//                     visible: feature.getGeometry().getType() !== 'Point',
//                     fillColor: '#FF0000',
//                     strokeColor: '#FF0000',
//                     strokeWeight: 2,
//                   }));
//                 }}
//               />
//             )}
//           </GoogleMap>
//         </LoadScript>
//       </div>
//     </div>
//   );
// };

// export default AmbulanceMap;

// import React, { useEffect, useRef, useState } from "react";
// import { GoogleMap, LoadScript, Data } from "@react-google-maps/api";
// import Sidebar from "./MapSidebar";
// // import '../../assets/css/map.css';

// const mapContainerStyle = {
//   height: "97vh",
//   flexGrow: "1",
// };

// const center = {
//   lat: 28.603752,
//   lng: 77.230188,
// };

// const medicalUnitsApi = "https://procam.pythonanywhere.com/api/gps_unit/medicalunits";
// const ambulancesApi = "https://procam.pythonanywhere.com/api/gps_unit/ambulances";
// const ambulancePhotosApi = "https://procam.pythonanywhere.com/api/gps_unit_photo/";

// const AmbulanceMap = () => {
//   const [map, setMap] = useState(null);
//   const medicalMarkersRef = useRef([]); // Ref for medical markers (static)
//   const ambulanceMarkersRef = useRef([]); // Ref for ambulance markers (dynamic)
//   const [geoJsonData, setGeoJsonData] = useState(null);

//   useEffect(() => {
//     // Fetch the GeoJSON file
//     // alert('fetching route');
//     fetch("/route.json")
//       .then((response) => response.json())
//       .then((data) => setGeoJsonData(data))
//       .catch((error) => console.error("Error loading GeoJSON file:", error));
//   }, []);

//   useEffect(() => {
//     if (map) {
//       // Fetch medical markers once
//       fetchMedicalMarkersFromApi();

//       // Fetch and update ambulance markers every 5 seconds
//       fetchAmbulanceMarkersFromApi();
//       const interval = setInterval(fetchAmbulanceMarkersFromApi, 5000);

//       return () => clearInterval(interval); // Clear interval on unmount
//     }
//   }, [map]);

//   const fetchMedicalMarkersFromApi = async () => {
//     try {
//       const response = await fetch(medicalUnitsApi);
//       const data = await response.json();

//       // Create and add medical markers
//       const medicalMarkers = data.map((item) => {
//         const marker = new window.google.maps.Marker({
//           position: { lat: item.latitude, lng: item.longitude },
//           map, // Add to the map
//           title: item.name,
//           icon: {
//             url: "icons/medical-center.svg",
//             labelOrigin: new window.google.maps.Point(30, 40),
//           },
//           label: {
//             text: item.name, // Marker label
//             color: "white",
//             fontWeight: "bold",
//             fontSize: "15px",
//           },
//         });

//         // Add info window to each marker
//         const infoWindow = new window.google.maps.InfoWindow({
//           content: `
//             <div>
//               <h4>${item.name}</h4>
//               <p>Unit Type: ${item.unit_type}</p>
//               <p>Latitude: ${item.latitude}</p>
//               <p>Longitude: ${item.longitude}</p>
//             </div>
//           `,
//         });

//         marker.addListener("click", () => {
//           infoWindow.open(map, marker);
//         });

//         return marker;
//       });

//       // Store medical markers
//       medicalMarkersRef.current = medicalMarkers;
//     } catch (error) {
//       console.error("Error fetching medical markers:", error);
//     }
//   };

//   const fetchAmbulanceMarkersFromApi = async () => {
//     try {
//       const responseAmbulance = await fetch(ambulancesApi);
//       const ambulanceData = await responseAmbulance.json();

//       // Update ambulance markers
//       ambulanceData.forEach((item) => {
//         const existingMarker = ambulanceMarkersRef.current.find(
//           (marker) => marker.id === item.id
//         );

//         if (existingMarker) {
//           console.log('Update existing marker');
//           // Update existing marker
//           existingMarker.setPosition({ lat: item.latitude, lng: item.longitude });
//           existingMarker.setIcon({
//             url:
//               item.unit_type.trim() === "LEAD CAR"
//                 ? "icons/lead-car-icon.png"
//                 : item.unit_type.trim() === "TAIL CAR"
//                   ? "icons/tail-car-icon.png"
//                   : "icons/ambulance-location-icon.svg",
//             labelOrigin: new window.google.maps.Point(30, 10),
//           });

//           existingMarker.setLabel({
//             text: item.name,
//             color:
//               item.unit_type.trim() === "LEAD CAR" || item.unit_type.trim() === "TAIL CAR"
//                 ? "white"
//                 : "red",
//             fontWeight: "bold",
//             fontSize: "15px",
//           });
//         } else {
//           // Create a new marker if it doesn't exist
//           const newMarker = new window.google.maps.Marker({
//             position: { lat: item.latitude, lng: item.longitude },
//             map,
//             title: item.name,
//             icon: {
//               url:
//                 item.unit_type.trim() === "LEAD CAR"
//                   ? "icons/lead-car-icon.png"
//                   : item.unit_type.trim() === "TAIL CAR"
//                     ? "icons/tail-car-icon.png"
//                     : "icons/ambulance-location-icon.svg",
//               labelOrigin: new window.google.maps.Point(30, 10),
//             },
//             label: {
//               text: item.name,
//               color: "red",
//               fontWeight: "bold",
//               fontSize: "15px",
//             },
//             id: item.id, // Add a unique identifier for the marker
//           });

//           const infoWindow = new window.google.maps.InfoWindow({
//             content: `
//               <div>
//                 <h4>${item.name}</h4>
//                 <p>Latitude: ${item.latitude}</p>
//                 <p>Longitude: ${item.longitude}</p>
//               </div>
//             `,
//           });

//           newMarker.addListener("click", () => {
//             infoWindow.open(map, newMarker);
//           });

//           ambulanceMarkersRef.current.push(newMarker);
//         }
//       });

//       // Remove markers that are no longer valid
//       ambulanceMarkersRef.current = ambulanceMarkersRef.current.filter((marker) => {
//         const isStillValid = ambulanceData.some((item) => item.id === marker.id);
//         if (!isStillValid) {
//           marker.setMap(null); // Remove marker from map
//         }
//         return isStillValid;
//       });
//     } catch (error) {
//       console.error("Error fetching ambulance markers:", error);
//     }
//   };

//   return (
//     <div>
//       {/* <div id="sidebar">
//         <Sidebar ambulancePhotosApi={ambulancePhotosApi} />
//       </div> */}
//       <div>
//         <div id="map">
//           <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
//             <GoogleMap
//               mapContainerStyle={mapContainerStyle}
//               center={center}
//               zoom={14}
//               options={{
//                 mapTypeControl: false,
//                 streetViewControl: false,
//                 fullscreenControl: false,
//                 scaleControl: false,
//                 rotateControl: false,
//                 zoomControl: true,
//               }}
//               onLoad={(mapInstance) => setMap(mapInstance)}
//             >
//               {geoJsonData && (
//                 <Data
//                   onLoad={(data) => {
//                     data.addGeoJson(geoJsonData);
//                     data.setStyle((feature) => ({
//                       visible: feature.getGeometry().getType() !== "Point",
//                       fillColor: "#FF0000",
//                       strokeColor: "#FF0000",
//                       strokeWeight: 2,
//                     }));
//                   }}
//                 />
//               )}
//             </GoogleMap>
//           </LoadScript>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default AmbulanceMap;

import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  GoogleMap,
  LoadScript,
  Data,
  useJsApiLoader,
  Marker,
  InfoWindow,
} from '@react-google-maps/api';
import Sidebar from './MapSidebar';
import { TfiMenu } from 'react-icons/tfi';
import pro360Logo from '../../assets/images/pro360-logo.png';
import { Grid, IconButton, useMediaQuery, useTheme } from '@mui/material';
import eventService from '../../services/eventService';
import { filter, find, startsWith } from 'lodash';
import axios from 'axios';

const mapContainerStyle = {
  height: '97vh',
  flexGrow: '1',
};

const center = {
  lat: 28.603752,
  lng: 77.230188,
};

const EMAIL = '9512292402';
const PASSWORD = 'Iks@5456';

const LOGIN_URL = 'https://web.onelap.in/api/session';
const WS_URL = 'wss://web.onelap.in/api/socket';
const BASE_URL = 'https://web.onelap.in';
const DEVICES_URL = `${BASE_URL}/api/devices`;

const containerStyle = {
  width: '100vw',
  height: '100vh',
};

const carIconSVG = encodeURIComponent(`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
  <path fill="#3399cc" d="M480 256c0-32-64-64-160-96s-160 0-192 32C64 192 0 224 0 256v32c0 35.3 28.7 64 64 64h16c0 17.7 14.3 32 32 32s32-14.3 32-32h224c0 17.7 14.3 32 32 32s32-14.3 32-32h16c35.3 0 64-28.7 64-64v-32z"/>
  <circle cx="128" cy="320" r="32" fill="#e6f2f8"/>
  <circle cx="128" cy="320" r="16" fill="#336699"/>
  <circle cx="384" cy="320" r="32" fill="#e6f2f8"/>
  <circle cx="384" cy="320" r="16" fill="#336699"/>
  <rect x="160" y="176" width="192" height="48" rx="10" fill="#2a7aa8"/>
</svg>
`);

const iconUrls = {
  161339: 'https://cdn-icons-png.flaticon.com/512/744/744465.png', // red car
  161340: `data:image/svg+xml,${carIconSVG}`, // blue car
  default: 'https://cdn-icons-png.flaticon.com/512/744/744480.png', // default car
};

const AmbulanceMap = () => {
  const [map, setMap] = useState(null);
  const junctionMarkersRef = useState(null);
  const medicalMarkersRef = useRef([]); // Ref for medical markers (static)
  const ambulanceMarkersRef = useRef([]); // Ref for ambulance markers (dynamic)
  // const [geoJsonData, setGeoJsonData] = useState(null);
  const [showSidebar, setShowSidebar] = useState(false);
  const theme = useTheme();
  const [events, setEvents] = useState([]);
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  const [devices, setDevices] = useState([]);
  const medicalUnitsApi = `${process.env.REACT_APP_API_URL}/gps_unit/medicalunits`;
  const ambulancesApi = `${process.env.REACT_APP_API_URL}/gps_unit/ambulances`;
  const junctionsApi = `${process.env.REACT_APP_API_URL}/gps_unit/junctions`;
  const ambulancePhotosApi = `${process.env.REACT_APP_API_URL}/gps_unit_photo/gps_unit_photo_active_ev/${events?.id}`;

  useEffect(() => {
    const fetchEvents = async () => {
      const response = await eventService.getEvents();
      setEvents(find(response.data, { active: true }));
    };
    fetchEvents();
  }, []);

  // MUI breakpoints to check for mobile and tablet sizes
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery(theme.breakpoints.between('sm', 'md')); // Tablet (600px to 1024px)

  // useEffect(() => {
  //   // Fetch the GeoJSON file
  //   fetch('/route.json')
  //     .then((response) => response.json())
  //     .then((data) => setGeoJsonData(data))
  //     .catch((error) => console.error('Error loading GeoJSON file:', error));
  // }, []);

  const geojsonFileUrl = `${process.env.REACT_APP_IMAGE_URL}/mapfiles/${events?.kml}`; // URL or path to your GeoJSON file

  useEffect(() => {
    if (map && events?.kml) {
      fetch(geojsonFileUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then((geojsonData) => {
          // Add GeoJSON data to the map's data layer
          map.data.addGeoJson(geojsonData);

          const bounds = new window.google.maps.LatLngBounds();

          // Iterate through the GeoJSON features to extend the bounds
          map.data.forEach((feature) => {
            const geometry = feature.getGeometry();
            if (geometry.getType() === 'Point') {
              bounds.extend(geometry.get());
            } else if (geometry.getType() === 'LineString') {
              geometry.getArray().forEach((latLng) => {
                bounds.extend(latLng);
              });
            }
          });

          // Set the map’s center based on the bounds center
          map.setCenter(bounds.getCenter());

          // Adjust zoom level to fit the bounds
          map.fitBounds(bounds);

          // Style the features
          map.data.setStyle((feature) => ({
            visible: feature.getGeometry().getType() !== 'Point',
            fillColor: '#F38808',
            strokeColor: '#F38808',
            strokeWeight: 2,
          }));
        })
        .catch((error) => {
          console.error('Error loading GeoJSON file:', error);
        });
    }
  }, [map, events]);

  const [deviceLocations, setDeviceLocations] = useState({});
  const [connectionStatus, setConnectionStatus] = useState('Disconnected');
  const [debugLogs, setDebugLogs] = useState([]);
  const authToken = useRef(null);
  const ws = useRef(null);
  const reconnectTimeoutRef = useRef(null);
  const keepAliveIntervalRef = useRef(null);
  const connectionAttemptsRef = useRef(0);
  const [selectedMarker, setSelectedMarker] = useState(null);
  const LIBRARIES = ['places'];

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
    libraries: LIBRARIES,
  });

  const addLog = (message) => {
    setDebugLogs((prev) =>
      [...prev, `${new Date().toLocaleTimeString()}: ${message}`].slice(-10),
    );
  };

  const fetchSession = async () => {
    try {
      addLog('Attempting to login with provided credentials...');

      const res = await axios.post(
        LOGIN_URL,
        new URLSearchParams({ email: EMAIL, password: PASSWORD }),
        {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          withCredentials: true,
        },
      );

      addLog(`Login response received: ${res.status}`);

      if (res.data) {
        // Based on the logs, it seems the API returns a user ID that can be used as a token
        if (
          typeof res.data === 'number' ||
          (typeof res.data === 'string' && !isNaN(res.data))
        ) {
          authToken.current = res.data.toString();
          addLog(`Auth token extracted: ${authToken.current}`);
          return true;
        }

        // If it's an object, look for common auth fields
        if (res.data.id || res.data.userId || res.data.sessionId) {
          authToken.current = (
            res.data.id ||
            res.data.userId ||
            res.data.sessionId
          ).toString();
          addLog(`User ID extracted as auth token: ${authToken.current}`);
          return true;
        }

        // Check for token field
        if (res.data.token) {
          authToken.current = res.data.token;
          addLog(`Token extracted: ${authToken.current}`);
          return true;
        }

        // If whole response is a string
        if (typeof res.data === 'string' && res.data.length > 0) {
          authToken.current = res.data;
          addLog(`Response data used as auth token: ${authToken.current}`);
          return true;
        }

        // Last resort: stringify response
        authToken.current = JSON.stringify(res.data);
        addLog('Full response stringified as auth token');
        return true;
      }

      addLog('No usable authentication data found in response');
      return false;
    } catch (err) {
      addLog(
        `Login failed: ${
          err.response ? JSON.stringify(err.response.data) : err.message
        }`,
      );
      return false;
    }
  };

  const extractLocations = (data) => {
    let locations = {};
    const walk = (obj) => {
      if (Array.isArray(obj)) obj.forEach(walk);
      else if (obj && typeof obj === 'object') {
        if (obj.deviceId && obj.latitude && obj.longitude) {
          locations[obj.deviceId] = {
            lat: obj.latitude,
            lng: obj.longitude,
            timestamp: new Date().toLocaleTimeString(),
            speed: obj.speed || 0,
            course: obj.course || 0,
          };
        }
        Object.values(obj).forEach(walk);
      }
    };
    walk(data);
    return locations;
  };

  const setupKeepAlive = () => {
    // Clear existing interval if any
    if (keepAliveIntervalRef.current) {
      clearInterval(keepAliveIntervalRef.current);
    }
    // Set up a new keep-alive interval
    keepAliveIntervalRef.current = setInterval(() => {
      if (ws.current && ws.current.readyState === WebSocket.OPEN) {
        try {
          // Send a ping/keep-alive message
          ws.current.send(JSON.stringify({ type: 'ping' }));
        } catch (err) {
          addLog(`Failed to send keep-alive: ${err.message}`);

          // If sending fails, try to reconnect
          if (ws.current) {
            ws.current.close();
          }
        }
      }
    }, 30000); // Send a ping every 30 seconds
  };

  const connectWebSocket = async (forceReauth = false) => {
    // Clear any existing reconnect timeout
    if (reconnectTimeoutRef.current) {
      clearTimeout(reconnectTimeoutRef.current);
      reconnectTimeoutRef.current = null;
    }

    // If force re-authentication or no token yet
    if (forceReauth || !authToken.current) {
      setConnectionStatus('Authenticating...');
      const success = await fetchSession();
      if (!success) {
        setConnectionStatus('Authentication failed. Check credentials.');
        connectionAttemptsRef.current++;

        // Exponential backoff for retry
        const delay = Math.min(
          30000,
          1000 * Math.pow(2, connectionAttemptsRef.current),
        );
        addLog(`Retrying authentication in ${delay / 1000} seconds...`);

        reconnectTimeoutRef.current = setTimeout(
          () => connectWebSocket(true),
          delay,
        );
        return;
      }
      // Reset connection attempts on successful auth
      connectionAttemptsRef.current = 0;
    }

    setConnectionStatus('Connecting...');

    try {
      // Close existing connection if any
      if (ws.current && ws.current.readyState !== WebSocket.CLOSED) {
        ws.current.close();
      }

      // Connect with the auth token in URL
      const wsUrl = `${WS_URL}?token=${encodeURIComponent(authToken.current)}`;
      addLog(`Connecting to WebSocket: ${wsUrl}`);

      ws.current = new WebSocket(wsUrl);

      ws.current.onopen = () => {
        addLog('✅ WebSocket connected');
        setConnectionStatus('Connected');
        connectionAttemptsRef.current = 0; // Reset connection attempts on success

        // Send authentication message if needed
        try {
          const authMessage = JSON.stringify({
            type: 'auth',
            token: authToken.current,
            email: EMAIL,
            password: PASSWORD,
          });
          ws.current.send(authMessage);
          addLog('Authentication message sent to WebSocket');

          // Set up keep-alive
          setupKeepAlive();
        } catch (err) {
          addLog(`Failed to send auth message: ${err.message}`);
        }
      };

      ws.current.onmessage = (event) => {
        try {
          // Reset reconnection attempts on successful message
          connectionAttemptsRef.current = 0;

          const data = JSON.parse(event.data);
          const truncatedData =
            event.data.length > 50
              ? `${event.data.substring(0, 50)}...`
              : event.data;
          addLog(`Message received: ${truncatedData}`);

          const newLocations = extractLocations(data);
          if (Object.keys(newLocations).length > 0) {
            addLog(`Extracted ${Object.keys(newLocations).length} locations`);
            setDeviceLocations((prev) => {
              // Merge with previous locations, keeping only newest data
              const updated = { ...prev };

              Object.entries(newLocations).forEach(([deviceId, info]) => {
                updated[deviceId] = info;
              });

              return updated;
            });
          }
        } catch (err) {
          addLog(`Parsing error: ${err.message}`);
        }
      };

      ws.current.onerror = (err) => {
        addLog(`WebSocket error: ${JSON.stringify(err)}`);
        setConnectionStatus('Error: Connection failed');

        // Don't need to explicitly reconnect here as onclose will be called
      };

      ws.current.onclose = (event) => {
        // Clear keep-alive interval
        if (keepAliveIntervalRef.current) {
          clearInterval(keepAliveIntervalRef.current);
          keepAliveIntervalRef.current = null;
        }

        addLog(
          `WebSocket closed (${event.code}: ${event.reason || 'No reason'})`,
        );
        setConnectionStatus(`Disconnected (${event.code}). Retrying...`);

        // Increment connection attempts
        connectionAttemptsRef.current++;

        // Calculate backoff delay (exponential with max of 30 seconds)
        const delay = Math.min(
          30000,
          1000 * Math.pow(1.5, connectionAttemptsRef.current),
        );

        // Check if we need to re-authenticate
        const shouldReauth =
          event.code === 1003 || // Unsupported data
          event.code === 1008 || // Policy violation (often auth issues)
          connectionAttemptsRef.current >= 5; // After several attempts, try re-auth

        addLog(
          `Reconnecting in ${delay / 1000} seconds${
            shouldReauth ? ' with re-authentication' : ''
          }...`,
        );

        // Set up reconnect with exponential backoff
        reconnectTimeoutRef.current = setTimeout(
          () => connectWebSocket(shouldReauth),
          delay,
        );
      };
    } catch (err) {
      addLog(`WebSocket connection error: ${err.message}`);
      setConnectionStatus('Connection error: ' + err.message);

      // Set up reconnect
      connectionAttemptsRef.current++;
      const delay = Math.min(
        30000,
        1000 * Math.pow(1.5, connectionAttemptsRef.current),
      );

      reconnectTimeoutRef.current = setTimeout(() => connectWebSocket(), delay);
    }
  };

  useEffect(() => {
    connectWebSocket();

    // Cleanup function
    return () => {
      if (ws.current) {
        ws.current.close();
      }
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (keepAliveIntervalRef.current) {
        clearInterval(keepAliveIntervalRef.current);
      }
    };
  }, []);

  // Calculate center of map based on device locations
  const mapCenter = React.useMemo(() => {
    if (Object.keys(deviceLocations).length === 0) return center;

    // Calculate average position of all devices
    let totalLat = 0;
    let totalLng = 0;
    const count = Object.keys(deviceLocations).length;

    Object.values(deviceLocations).forEach((location) => {
      totalLat += location.lat;
      totalLng += location.lng;
    });

    return {
      lat: totalLat / count,
      lng: totalLng / count,
    };
  }, [deviceLocations]);

  // useEffect(() => {
  //   if (map) {
  //     fetch(geojsonFileUrl)
  //       .then((response) => {
  //         if (!response.ok) {
  //           throw new Error('Network response was not ok');
  //         }
  //         return response.json();
  //       })
  //       .then((geojsonData) => {
  //         // Add GeoJSON data to the map's data layer
  //         map.data.addGeoJson(geojsonData);

  //         const bounds = new window.google.maps.LatLngBounds();

  //         // Iterate through the GeoJSON features to extend the bounds
  //         map.data.forEach((feature) => {
  //           console.log("feature",feature);

  //           const geometry = feature.getGeometry();
  //           if (geometry.getType() === 'Point') {
  //             bounds.extend(geometry.get());
  //           } else if (geometry.getType() === 'LineString') {
  //             geometry.getArray().forEach((latLng) => {
  //               bounds.extend(latLng);
  //             });
  //           }
  //         });

  //         const center = bounds.getCenter();

  //         // Set the map’s center based on the bounds center
  //         map.setCenter(center);

  //         // Adjust zoom level to fit the bounds (optional but helpful for the route)
  //         // map.fitBounds(bounds);

  //         // Style the features
  //         map.data.setStyle((feature) => ({
  //           visible: feature.getGeometry().getType() !== 'Point',
  //           fillColor: '#F38808',
  //           strokeColor: '#F38808',
  //           strokeWeight: 4,
  //         }));
  //       })
  //       .catch((error) => {
  //         console.error('Error loading GeoJSON file:', error);
  //       });
  //   }
  // }, [map, events]);

  useEffect(() => {
    if (map) {
      fetchMedicalMarkersFromApi();
      fetchJunctionMarkersFromApi();
      // const interval = setInterval(fetchAmbulanceMarkersFromApi, 5000);

      // return () => clearInterval(interval); // Clean up on unmount
    }
  }, [map]);

  const closeModal = () => {
    setSelectedPhoto(null); // Close the modal
  };

  // const animateMarkerMove = (marker, newLat, newLng, duration = 1000) => {
  //   const startLatLng = marker.getPosition();
  //   const startLat = startLatLng.lat();
  //   const startLng = startLatLng.lng();

  //   const deltaLat = newLat - startLat;
  //   const deltaLng = newLng - startLng;

  //   let startTime = null;

  //   const step = (timestamp) => {
  //     if (!startTime) startTime = timestamp;

  //     const progress = Math.min((timestamp - startTime) / duration, 1);

  //     const lat = startLat + deltaLat * progress;
  //     const lng = startLng + deltaLng * progress;

  //     marker.setPosition(new window.google.maps.LatLng(lat, lng));

  //     if (progress < 1) {
  //       window.requestAnimationFrame(step);
  //     }
  //   };

  //   window.requestAnimationFrame(step);
  // };

  const fetchMedicalMarkersFromApi = async () => {
    try {
      const response = await fetch(medicalUnitsApi);
      const data = await response.json();
      const medicalData = data?.map((item) => {
        return {
          ...item,
          latitude: parseFloat(item?.latitude),
          longitude: parseFloat(item?.longitude),
        };
      });

      // Create and add medical markers
      const medicalMarkers = medicalData.map((item) => {
        const marker = new window.google.maps.Marker({
          position: { lat: item.latitude, lng: item.longitude },
          map, // Add to the map
          title: item.name,
          icon: {
            url:
              item.unit_type === 'HOSPITAL'
                ? 'icons/hospital.svg'
                : 'icons/medical-center.svg',
            // labelOrigin: new window.google.maps.Point(10, 30),
            scaledSize: new window.google.maps.Size(37, 40),
            labelOrigin: new window.google.maps.Point(18, 45),
            fontWeight: 'bold',
          },
          label: {
            text: item.name, // Marker label
            color: 'white',
            fontWeight: 'bold',
            fontSize: '12px',
          },
        });

        // Add info window to each marker
        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div>
              <h4>${item.name}</h4>
              <p>Unit Type: ${item.unit_type}</p>
              <p>Latitude: ${item.latitude}</p>
              <p>Longitude: ${item.longitude}</p>
            </div>
          `,
        });

        marker.addListener('click', () => {
          infoWindow.open(map, marker);
        });

        return marker;
      });

      // Store medical markers
      medicalMarkersRef.current = medicalMarkers;
    } catch (error) {
      console.error('Error fetching medical markers:', error);
    }
  };

  const fetchJunctionMarkersFromApi = async () => {
    try {
      const response = await fetch(junctionsApi);
      const data = await response.json();
      const junctionData = data?.map((item) => {
        return {
          ...item,
          latitude: parseFloat(item?.latitude),
          longitude: parseFloat(item?.longitude),
        };
      });

      // Create and add junction markers
      const junctionMarkers = junctionData.map((item) => {
        const marker = new window.google.maps.Marker({
          position: { lat: item.latitude, lng: item.longitude },
          map, // Add to the map
          title: item.name,
          icon: {
            url: '/icons/junction.svg',
            // labelOrigin: new window.google.maps.Point(10, 30),
            scaledSize: new window.google.maps.Size(37, 40),
            labelOrigin: new window.google.maps.Point(18, 45),
            fontWeight: 'bold',
          },
          label: {
             text: item.name, // Marker label
            color: 'white',
            fontWeight: 'bold',
            fontSize: '12px',
          },
        });

        // Add info window to each marker
        const infoWindow = new window.google.maps.InfoWindow({
          content: `
            <div>
              <h4>${item.name}</h4>
              <p>Unit Type: ${item.unit_type}</p>
              <p>Latitude: ${item.latitude}</p>
              <p>Longitude: ${item.longitude}</p>
            </div>
          `,
        });

        marker.addListener('click', () => {
          infoWindow.open(map, marker);
        });

        return marker;
      });

      // Store medical markers
      junctionMarkersRef.current = junctionMarkers;
    } catch (error) {
      console.error('Error fetching medical markers:', error);
    }
  };

  const fetchAmbulanceMarkersFromApi = async () => {
    try {
      const responseAmbulance = await fetch(ambulancesApi);
      const data = await responseAmbulance?.json();
      const ambulanceData = data?.map((item) => {
        return {
          ...item,
          latitude: parseFloat(item?.latitude),
          longitude: parseFloat(item?.longitude),
        };
      });

      // Update ambulance markers
      ambulanceData.forEach((item) => {
        const existingMarker = ambulanceMarkersRef.current.find(
          (marker) => marker.id === item.id,
        );

        console.log('ambulanceData', ambulanceData);

        if (existingMarker) {
          // Update existing marker
          existingMarker.setPosition({
            lat: item.latitude,
            lng: item.longitude,
          });

          // animateMarkerMove(existingMarker, item.latitude, item.longitude);

          existingMarker.setIcon({
            url:
              item.unit_type.trim() === 'LEAD CAR'
                ? 'icons/icon-lead-car.svg'
                : item.unit_type.trim() === 'TAIL CAR'
                  ? 'icons/icon-tail-car.svg'
                  : 'icons/ambulance-location-icon.svg',
            // labelOrigin: new window.google.maps.Point(26.4, 11),
            scaledSize: new window.google.maps.Size(50, 70),
            labelOrigin:
              item.unit_type.trim() === 'LEAD CAR' ||
              item.unit_type.trim() === 'TAIL CAR'
                ? new window.google.maps.Point(24, 40)
                : new window.google.maps.Point(24, 20),
          });

          existingMarker.setLabel({
            text: item.name,
            color: 'white',
            fontWeight: 'bold',
            fontSize: '10px',
          });
        } else {
          // Create a new marker if it doesn't exist
          const newMarker = new window.google.maps.Marker({
            position: { lat: item.latitude, lng: item.longitude },
            map,
            title: item.name,
            icon: {
              url:
                item.unit_type.trim() === 'LEAD CAR'
                  ? 'icons/lead-car-icon.png'
                  : item.unit_type.trim() === 'TAIL CAR'
                    ? 'icons/tail-car-icon.png'
                    : 'icons/ambulance-location-icon.svg',
              scaledSize: new window.google.maps.Size(50, 70),
              labelOrigin:
                item.unit_type.trim() === 'LEAD CAR' ||
                item.unit_type.trim() === 'TAIL CAR'
                  ? new window.google.maps.Point(24, 40)
                  : new window.google.maps.Point(24, 20),
            },
            label: {
              text: item.name,
              color: 'white',
              fontWeight: 'bold',
              fontSize: '10px',
            },
            id: item.id, // Add a unique identifier for the marker
          });

          const infoWindow = new window.google.maps.InfoWindow({
            content: `
              <div>
                <h4>${item.name}</h4>
                <p>Latitude: ${item.latitude}</p>
                <p>Longitude: ${item.longitude}</p>
              </div>
            `,
          });

          newMarker.addListener('click', () => {
            infoWindow.open(map, newMarker);
          });

          ambulanceMarkersRef.current.push(newMarker);
        }
      });

      // Remove markers that are no longer valid
      ambulanceMarkersRef.current = ambulanceMarkersRef.current.filter(
        (marker) => {
          const isStillValid = ambulanceData.some(
            (item) => item.id === marker.id,
          );
          if (!isStillValid) {
            marker.setMap(null); // Remove marker from map
          }
          return isStillValid;
        },
      );
    } catch (error) {
      console.error('Error fetching ambulance markers:', error);
    }
  };

  const fetchDevices = useCallback(async () => {
    try {
      const res = await fetch(DEVICES_URL, { credentials: 'include' });
      if (!res.ok) return [];
      const data = await res.json();
      setDevices(data);
      return data;
    } catch (err) {
      console.error('❌ Fetch devices error:', err);
      return [];
    }
  }, []);

  useEffect(() => {
    fetchDevices();
  }, []);

  const mapStyle = [
    { elementType: 'geometry', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.stroke', stylers: [{ color: '#242f3e' }] },
    { elementType: 'labels.text.fill', stylers: [{ color: '#746855' }] },
    {
      featureType: 'administrative.locality',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'geometry',
      stylers: [{ color: '#263c3f' }],
    },
    {
      featureType: 'poi.park',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#6b9a76' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry',
      stylers: [{ color: '#38414e' }],
    },
    {
      featureType: 'road',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#212a37' }],
    },
    {
      featureType: 'road',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#9ca5b3' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry',
      stylers: [{ color: '#746855' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [{ color: '#1f2835' }],
    },
    {
      featureType: 'road.highway',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#f3d19c' }],
    },
    {
      featureType: 'transit',
      elementType: 'geometry',
      stylers: [{ color: '#2f3948' }],
    },
    {
      featureType: 'transit.station',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#d59563' }],
    },
    {
      featureType: 'water',
      elementType: 'geometry',
      stylers: [{ color: '#17263c' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.fill',
      stylers: [{ color: '#515c6d' }],
    },
    {
      featureType: 'water',
      elementType: 'labels.text.stroke',
      stylers: [{ color: '#17263c' }],
    },
  ];

  if (!isLoaded) return <div>Loading…</div>;

  return (
    // <Grid
    //   container
    //   sx={{
    //     height: '100vh',
    //     margin: '0',
    //     position: 'relative',
    //     overflowX: 'hidden', // Prevent horizontal scrolling
    //   }}
    // >
    //   {/* Sidebar on the left */}
    //   {showSidebar && (
    //     <Grid
    //       item
    //       xs={showSidebar ? 4 : 0} // Full width on small screens (xs)
    //       sm={showSidebar ? 4 : 0} // 4/12 on small screens and above
    //       md={showSidebar ? 3 : 0} // 3/12 on medium screens and larger
    //       sx={{
    //         overflow: 'auto',
    //         transition: 'transform 0.3s ease',
    //         transform: showSidebar ? 'translateX(0)' : 'translateX(-100%)',
    //         // display: { xs: 'none', sm: 'block' }, // Hide sidebar on mobile (xs)
    //       }}
    //     >
    //       <Sidebar
    //         ambulancePhotosApi={ambulancePhotosApi}
    //         setShowSidebar={setShowSidebar}
    //         eventDetails={events}
    //       />
    //     </Grid>
    //   )}

    //   {/* Sidebar Toggle Button for small screens */}
    //   {!showSidebar && (
    //     <Grid
    //       item
    //       xs={2}
    //       sx={{
    //         // display: { xs: 'flex', sm: 'none' }, // Show button only on small screens
    //         position: 'absolute',
    //         top: '1rem',
    //         left: '1rem',
    //         zIndex: 999,
    //       }}
    //     >
    //       <IconButton
    //         sx={{
    //           color: '#fff',
    //           fontSize: '25px',
    //           cursor: 'pointer',
    //         }}
    //         onClick={() => setShowSidebar(!showSidebar)}
    //       >
    //         <TfiMenu />
    //       </IconButton>
    //     </Grid>
    //   )}

    //   {/* Main content: Map and Logo */}
    //   <Grid
    //     item
    //     xs={showSidebar ? 7.9 : 12} // Full width on small screens (xs)
    //     sm={showSidebar ? 7.9 : 12} // 8/12 on small screens and above
    //     md={showSidebar ? 8.9 : 12} // 9/12 on medium screens and larger
    //     sx={{
    //       position: 'relative',
    //       display: 'flex',
    //       flexDirection: 'column',
    //       justifyContent: 'center',
    //       paddingTop: {
    //         xs: showSidebar ? '1rem' : '0rem',
    //       }, // Adjust padding for logo on small screens
    //     }}
    //   >
    //     {/* Center Logo on the map */}
    //     <div
    //       style={{
    //         position: 'absolute',
    //         top: '2rem',
    //         right: isMobile ? '-2rem' : isTablet ? '-4rem' : '-5rem',
    //         transform: 'translateX(-50%)',
    //         zIndex: 999,
    //       }}
    //     >
    //       <img
    //         src={pro360Logo}
    //         alt='Logo'
    //         className='responsive-logo'
    //         style={{
    //           maxWidth: '20vw', // Default logo size for larger screens
    //           height: 'auto',
    //           transition: 'max-width 0.3s ease',
    //         }}
    //       />
    //     </div>

    //     {/* Google Map */}
    //     <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
    //       <GoogleMap
    //         mapContainerStyle={mapContainerStyle}
    //         center={center}
    //         // zoom={12}
    //         options={{
    //           styles: mapStyle,
    //           mapTypeControl: false,
    //           streetViewControl: false,
    //           fullscreenControl: false,
    //           scaleControl: false,
    //           rotateControl: false,
    //           zoomControl: true,
    //         }}
    //         onLoad={(mapInstance) => setMap(mapInstance)}
    //       >
    //         <Data
    //           onLoad={(data) => {
    //             data.setStyle((feature) => ({
    //               visible: feature.getGeometry().getType() !== 'Point',
    //               fillColor: '#FF0000',
    //               strokeColor: '#FF0000',
    //               strokeWeight: 2,
    //             }));
    //           }}
    //         />
    //       </GoogleMap>
    //     </LoadScript>
    //   </Grid>
    // </Grid>

    <Grid
      container
      sx={{
        height: '100vh',
        margin: '0',
        position: 'relative',
        overflow: 'hidden', // Prevent scrolling on the map container
      }}
    >
      {/* Sidebar on the left */}
      {/* {showSidebar && (
        <Grid
          item
          xs={showSidebar ? 4 : 0} // Full width on small screens (xs)
          sm={showSidebar ? 4 : 0} // 4/12 on small screens and above
          md={showSidebar ? 3 : 0} // 3/12 on medium screens and larger
          sx={{
            overflowY: 'auto', // Enable vertical scrolling on the sidebar
            height: '100vh', // Full height for sidebar to scroll
            transition: 'transform 0.3s ease',
            transform: showSidebar ? 'translateX(0)' : 'translateX(-100%)',
          }}
        >
          <Sidebar
            ambulancePhotosApi={ambulancePhotosApi}
            setShowSidebar={setShowSidebar}
            eventDetails={events}
            setSelectedPhoto={setSelectedPhoto}
            selectedPhoto={selectedPhoto}
          />
        </Grid>
      )} */}

      {/* Sidebar Toggle Button for small screens */}
      {/* {!showSidebar && (
        <Grid
          item
          xs={2}
          sx={{
            position: 'absolute',
            top: '1rem',
            left: '1rem',
            zIndex: 999,
          }}
        >
          <IconButton
            sx={{
              color: '#fff',
              fontSize: '25px',
              cursor: 'pointer',
            }}
            onClick={() => setShowSidebar(!showSidebar)}
          >
            <TfiMenu />
          </IconButton>
        </Grid>
      )} */}

      {/* Main content: Map and Logo */}
      <Grid
        item
        xs={12} // Full width on small screens (xs)
        sm={12} // 8/12 on small screens and above
        md={12} // 9/12 on medium screens and larger
        // xs={showSidebar ? 7.9 : 12} // Full width on small screens (xs)
        // sm={showSidebar ? 7.9 : 12} // 8/12 on small screens and above
        // md={showSidebar ? 8.9 : 12} // 9/12 on medium screens and larger
        sx={{
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          // paddingTop: {
          //   xs: showSidebar ? '1rem' : '0rem',
          // },
          overflow: 'hidden', // Prevent scrolling on the map container
        }}
      >
        {/* Center Logo on the map */}
        <div
          style={{
            position: 'absolute',
            top: '2rem',
            right: isMobile ? '-2rem' : isTablet ? '-4rem' : '-5rem',
            transform: 'translateX(-50%)',
            zIndex: 999,
          }}
        >
          <img
            src={pro360Logo}
            alt='Logo'
            className='responsive-logo'
            style={{
              maxWidth: '20vw',
              height: 'auto',
              transition: 'max-width 0.3s ease',
            }}
          />
        </div>

        {/* Google Map */}
        {/* <LoadScript
          googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
          libraries={['places']}
        > */}
        <GoogleMap
          mapContainerStyle={mapContainerStyle}
          center={center}
          options={{
            styles: mapStyle,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: false,
            scaleControl: false,
            rotateControl: false,
            zoomControl: true,
          }}
          onLoad={(mapInstance) => setMap(mapInstance)}
          zoom={10}
        >
          <Data
            onLoad={(data) => {
              data.setStyle((feature) => ({
                visible: feature.getGeometry().getType() !== 'Point',
                fillColor: '#FF0000',
                strokeColor: '#FF0000',
                strokeWeight: 2,
              }));
            }}
          />
          {/* {Object.entries(deviceLocations).map(([deviceId, info]) => (
              <Marker
                key={deviceId}
                position={info}
                icon={{
                  url: iconUrls[deviceId] || iconUrls['default'],
                  scaledSize: new window.google.maps.Size(40, 40),
                  // Add rotation based on course if available
                  ...(info.course !== undefined && {
                    rotation: info.course,
                  }),
                }}
                label={{
                  text: `${deviceId}`,
                  color: '#000',
                  fontSize: '12px',
                  fontWeight: 'bold',
                }}
              />
            ))} */}
          {console.log('deviceLocations,', deviceLocations, devices)}
          {Object.entries(deviceLocations).map(([deviceId, info]) => (
            // console.log("find(devices,{id : deviceId})",find(devices,{id : parseInt(deviceId)}),devices,deviceId)
            <Marker
              key={deviceId}
              position={info}
              icon={{
                url: startsWith(
                  find(devices, { id: parseInt(deviceId) })?.name,
                  'T',
                )
                  ? 'icons/icon-tail-car.svg'
                  : startsWith(
                        find(devices, { id: parseInt(deviceId) })?.name,
                        'L',
                      )
                    ? 'icons/icon-lead-car.svg'
                    : 'icons/ambulance-location-icon.svg',
                scaledSize: new window.google.maps.Size(50, 70),
                labelOrigin:
                  startsWith(
                    find(devices, { id: parseInt(deviceId) })?.name,
                    'T',
                  ) ||
                  startsWith(
                    find(devices, { id: parseInt(deviceId) })?.name,
                    'L',
                  )
                    ? new window.google.maps.Point(24, 40)
                    : new window.google.maps.Point(24, 20), // Adjust Y for better positioning
                ...(info.course !== undefined && {
                  rotation: info.course,
                }),
              }}
              label={{
                text: find(devices, { id: parseInt(deviceId) })?.name,
                color: 'white',
                fontWeight: 'bold',
                fontSize: '10px',
              }}
              onClick={() => {
                setSelectedMarker({ ...info, deviceId });
              }}
            />
          ))}

          {selectedMarker && (
            <InfoWindow
              position={{
                lat: selectedMarker.lat,
                lng: selectedMarker.lng,
              }}
              onCloseClick={() => setSelectedMarker(null)}
              options={{
                pixelOffset: new window.google.maps.Size(0, -30), // Offset upward by 40 pixels
              }}
            >
              <div>
                <h4>
                  {find(devices, { id: parseInt(selectedMarker.deviceId) })
                    ?.name || selectedMarker.deviceId}
                </h4>
                <p>Unit Type: GPS Device</p>
                <p>Latitude: {selectedMarker.lat}</p>
                <p>Longitude: {selectedMarker.lng}</p>
              </div>
            </InfoWindow>
          )}
        </GoogleMap>
        {/* </LoadScript> */}
      </Grid>
      <PhotoModal photoPath={selectedPhoto} onClose={closeModal} />
    </Grid>

    // <div style={{ display: 'flex', height: '100vh', margin: '8px' }}>
    //   {/* Sidebar on the left */}
    //   {showSidebar ? (
    //     <div style={{ width: '365px', overflow: 'auto' }}>
    //       <Sidebar
    //         ambulancePhotosApi={ambulancePhotosApi}
    //         setShowSidebar={setShowSidebar}
    //       />
    //     </div>
    //   ) : (
    //     <div
    //       style={{
    //         position: 'absolute',
    //         top: '1rem',
    //         left: '20px',
    //         zIndex: 999,
    //       }}
    //     >
    //       <TfiMenu
    //         style={{ color: '#007bff', fontSize: '25px', cursor: 'pointer' }}
    //         onClick={() => setShowSidebar(true)}
    //       />
    //     </div>
    //   )}

    //   {/* Map on the right */}
    //   <div style={{ flexGrow: 1 }}>
    //     <div
    //       style={{
    //         position: 'absolute',
    //         top: '1rem',
    //         left: '50%', // Center the logo horizontally
    //         transform: 'translateX(-50%)', // Adjust for perfect centering
    //         zIndex: 999,
    //       }}
    //     >
    //       <img
    //         src={pro360Logo}
    //         alt='Logo'
    //         className='responsive-logo'
    //         style={{
    //           maxWidth: '20vw', // Default for larger screens
    //           height: 'auto',
    //           transition: 'max-width 0.3s ease',
    //         }}
    //       />
    //     </div>

    //     <LoadScript googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}>
    //       <GoogleMap
    //         mapContainerStyle={mapContainerStyle}
    //         center={center}
    //         zoom={14}
    //         options={{
    //           styles: mapStyle,
    //           mapTypeControl: false,
    //           streetViewControl: false,
    //           fullscreenControl: false,
    //           scaleControl: false,
    //           rotateControl: false,
    //           zoomControl: true,
    //         }}
    //         onLoad={(mapInstance) => setMap(mapInstance)}
    //       >
    //         <Data
    //           onLoad={(data) => {
    //             data.setStyle((feature) => ({
    //               visible: feature.getGeometry().getType() !== 'Point',
    //               fillColor: '#FF0000',
    //               strokeColor: '#FF0000',
    //               strokeWeight: 2,
    //             }));
    //           }}
    //         />
    //       </GoogleMap>
    //     </LoadScript>
    //   </div>
    // </div>
  );
};

export default AmbulanceMap;

const PhotoModal = ({ photoPath, onClose }) => {
  if (!photoPath) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
      onClick={onClose}
    >
      <div
        style={{
          position: 'relative',
          backgroundColor: 'white',
          padding: '10px',
          borderRadius: '8px',
          maxWidth: '90vw', // Makes the modal container responsive
          maxHeight: '90vh', // Limits the modal size to 90% of the viewport
          display: 'flex',
          justifyContent: 'center', // Centering the image horizontally
          alignItems: 'center', // Centering the image vertically
        }}
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside modal
      >
        <img
          src={`${process.env.REACT_APP_IMAGE_URL}/images/${photoPath}`}
          alt='Photo'
          style={{
            maxWidth: '100%', // Ensure image is fully responsive
            maxHeight: '80vh', // Limit image size to avoid overflowing vertically
            borderRadius: '8px',
          }}
        />
        <button
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '20px',
            cursor: 'pointer',
          }}
        >
          X
        </button>
      </div>
    </div>
  );
};
